export function formatDateTime(input) {
    if (!input) return '-'
    const d = new Date(input)
    if (isNaN(d.getTime())) return String(input)
    const y = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const hh = String(d.getHours()).padStart(2, '0')
    const mi = String(d.getMinutes()).padStart(2, '0')
    const ss = String(d.getSeconds()).padStart(2, '0')
    return `${y}-${mm}-${dd} ${hh}:${mi}:${ss}`
}

export function formatDateTimeMinute(input) {
    if (!input) return '-'
    const d = new Date(input)
    if (isNaN(d.getTime())) return String(input)
    const y = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const hh = String(d.getHours()).padStart(2, '0')
    const mi = String(d.getMinutes()).padStart(2, '0')
    return `${y}-${mm}-${dd} ${hh}:${mi}`
}

